import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import groups, { Action as GroupsAction } from './groups';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import idealistDayEvents, {
  Action as IdealistDayEventsAction,
} from './idealistDayEvents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import listings, { Action as ListingsAction } from './listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import searchReducer, { Action as SearchAction } from './search';

export type Action = IdealistDayEventsAction | GroupsAction | ListingsAction;

// eslint-disable-next-line import/no-default-export
export default combineReducers<
  {
    groups: typeof groups;
    idealistDayEvents: typeof idealistDayEvents;
    listings: typeof listings;
    search: typeof searchReducer;
  },
  GroupsAction | IdealistDayEventsAction | ListingsAction | SearchAction
>({
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  groups,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => { byGroupI... Remove this comment to see the full error message
  idealistDayEvents,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  listings,
  // @ts-expect-error ts-migrate(2322) FIXME: Type '(state: State, action: Action) => State' is ... Remove this comment to see the full error message
  search: searchReducer,
});
